import React from 'react';
import usePlayback from './usePlayback';

// Replaces the timeline in step mode: one chip per step, timing computed automatically
export default function StepStrip({
    steps,
    stepTimes,
    invalidSteps,
    currentStep,        // -1 = formation
    currentTime,
    isPlaying,
    playEnd,
    canUndo,
    canRedo,
    onSelectStep,
    onAddStep,
    onDeleteStep,
    onPlayAll,
    onPlayStep,
    onPause,
    onTimeChange,
    onPlayEnd,
    onUndo,
    onRedo,
}) {
    usePlayback(isPlaying, currentTime, playEnd, onTimeChange, onPlayEnd);

    const total = stepTimes.length ? stepTimes[stepTimes.length - 1].end : 0;
    const playingIdx = isPlaying ? stepTimes.findIndex(s => currentTime >= s.start && currentTime < s.end) : -1;

    return (
        <div className="step-strip">
            <div style={{ display: 'flex', gap: '4px' }}>
                <button className="btn btn-sm btn-primary" style={{ minWidth: '64px' }}
                    onClick={isPlaying ? onPause : onPlayAll} disabled={!steps.length}
                    title="Reproducir toda la jugada">
                    {isPlaying ? 'Pausar' : '▶ Todo'}
                </button>
                <button className="btn btn-sm btn-outline-primary"
                    onClick={onPlayStep} disabled={isPlaying || currentStep < 0}
                    title="Reproducir solo este paso">
                    ▶ Paso
                </button>
            </div>

            <div className="step-strip-chips">
                <button
                    className={`step-chip ${currentStep === -1 ? 'active' : ''}`}
                    onClick={() => onSelectStep(-1)}
                >
                    Formación
                </button>
                {steps.map((step, i) => {
                    const st = stepTimes[i];
                    const dur = st ? (st.end - st.start).toFixed(1) : '0.0';
                    const invalid = invalidSteps.includes(i);
                    return (
                        <div
                            key={i}
                            role="button"
                            tabIndex={0}
                            className={`step-chip ${currentStep === i ? 'active' : ''} ${playingIdx === i ? 'playing' : ''}`}
                            onClick={() => onSelectStep(i)}
                            onKeyDown={e => { if (e.key === 'Enter') onSelectStep(i); }}
                        >
                            {invalid && (
                                <span className="step-chip-warn" title="El pase/tiro de este paso ya no es válido: el jugador no tiene el disco">⚠</span>
                            )}
                            <span>Paso {i + 1}</span>
                            <span className="step-chip-time">{dur}s</span>
                            {currentStep === i && (
                                <button
                                    className="step-chip-delete"
                                    title="Eliminar paso"
                                    onClick={e => { e.stopPropagation(); onDeleteStep(i); }}
                                >
                                    ×
                                </button>
                            )}
                        </div>
                    );
                })}
                <button className="step-chip-add" onClick={onAddStep}
                    title={currentStep >= 0 && currentStep < steps.length - 1 ? 'Insertar un paso después del actual' : 'Añadir paso'}>
                    + Paso
                </button>
            </div>

            <span style={{ fontSize: '0.8rem', color: '#888', whiteSpace: 'nowrap' }}>
                {total.toFixed(1)}s
            </span>
            <div style={{ display: 'flex', gap: '4px' }}>
                <button className="btn btn-sm btn-outline-secondary" onClick={onUndo} disabled={!canUndo} title="Deshacer (Ctrl+Z)">⟲</button>
                <button className="btn btn-sm btn-outline-secondary" onClick={onRedo} disabled={!canRedo} title="Rehacer (Ctrl+Shift+Z)">⟳</button>
            </div>
        </div>
    );
}
